const theme = {
  palette: {
    primary: "#FDD540",
    secondary: "#376092",
    white: "#fff",
    primaryscale: ["#FFC01E", "#FFAA2C"],
    secondaryscale: ["#5190DE", "#5195E9"],
    grayscale: ["#7E7E7E", "#FAFAFA"],
    text: "#57554B",
  },
};

export default theme;
